module.exports = __webpack_public_path__ + "img/logo14.a4a5c4a.jpg";